import translations from './antimony.content'
import type { Metal } from './types'

const t = translations
const dir = '/mine-my-phone/images/metals/antimony'

export const antimony: Metal = {
  id: 22,
  slug: 'antimony',
  name: t.name,
  symbol: 'Sb',
  mines: [
    {
      name: 'Xikuangshan (China, Hunan — "Antimony Capital of the World", world\'s largest known deposit)',
      region: 'Xikuangshan',
      coordinates: [111.45, 27.76],
    },
    {
      name: 'Sarylakh & Sentachan (Russia, Siberia)',
      region: 'Sarylakh & Sentachan',
      coordinates: [138.3, 64.2],
    },
    {
      name: 'Anzob mine (Tajikistan)',
      region: 'Anzob mine',
      coordinates: [69.28, 39.03],
    },
  ],
  countries: [
    { name: 'China', percent: 60 },
    { name: 'Tajikistan', percent: 17 },
    { name: 'Russia', percent: 13 },
    { name: 'Myanmar', percent: 4.5 },
    { name: 'Bolivia', percent: 3.7 },
    { name: 'Australia', percent: 2 },
    { name: 'Turkey', percent: 1.6 },
  ],
  content: {
    smartphone: {
      quantityScore: 1,
      quantityLabel: t.smartphone.label,
      parts: ['electronics'],
    },
    whatItDoes: t.whatItDoes,
    extraction: t.extraction,
    quickFact: t.quickFact,
    impacts: {
      environmental: { severity: 2, ...t.impacts.environmental },
      human: { severity: 2, ...t.impacts.human },
      geopolitical: { severity: 4, ...t.impacts.geopolitical },
    },
    supplyRisk: { score: 4, ...t.supplyRisk },
    recycling: { score: 3, ...t.recycling },
    photos: {
      hero: {
        src: `${dir}/01.jpg`,
        orientation: 'horizontal',
      },
      firstBento: [
        {
          src: `${dir}/02.jpg`,
          orientation: 'horizontal',
        },
      ],
    },
  },
}
